/**
 * Module: facet-wp
 * General facet-wp behaviors
 *
 * @package mindgrub-starter-theme
 */

/**
 * Initialize ui behaviors.
 */
function init() {
	if ('undefined' !== typeof FWP) {
		FWP.auto_refresh = false;
	}

	// Scroll to top after chance.
	$(document).on('facetwp-loaded', function() {
		let posts_per_page = 20;

		// Implies load more button was pressed.
		if ( 1 !== FWP.load_more_paged ) {
			let previous_page = FWP.load_more_paged - 1,
				last_index_before_paged = posts_per_page * previous_page - 1,
				last_item = $( '.beverage-tool__results' ).children().eq( last_index_before_paged + 1 );

			// Set focus on the first element's button of the new page.
			last_item.focus();
		}
	});

	// Facets.
	$( '.facets__filter-toggle' ).on( 'click', function ( e ) {
		$( this ).toggleClass( 'facets__filter-toggle--expanded' );

		if ( $( this ).hasClass( 'facets__filter-toggle--expanded' ) ) {
			$( this ).attr( 'aria-expanded', 'true' );
			$( this ).next( '.facets__options' ).slideDown();
		} else {
			$( this ).attr( 'aria-expanded', 'false' );
			$( this ).next( '.facets__options' ).slideUp();
		}
	} );

	// Beverage tool facet toggle.
	$( '.beverage-tool__toggle' ).on( 'click', function ( e ) {
		$( this ).find( '.menu-toggle' ).toggleClass( 'open' );

		if ( 'true' === $( this ).attr( 'aria-expanded' ) ) {
			$( this ).attr( 'aria-expanded', 'false' );
			$( this ).next( '.facets__filters' ).slideUp();
		} else {
			$( this ).attr( 'aria-expanded', 'true' );
			$( this ).next( '.facets__filters' ).slideDown();
		}
	} );
}

/**
 * Public API
 *
 * @type {Object}
 */
module.exports = {
	init: init
};



// WEBPACK FOOTER //
// ./scripts/components/facet-wp.js